import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'numberToMonth',
  standalone: false,
})
export class NumberToMonthPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: number): string {
    let months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return this.translateService.instant('label.' + months[value - 1]);
  }
}
